import classNames from 'classnames';
import React from 'react';

import { mapToCssModules } from '../util';
import css from './RichText.module.css';

interface CSSModule {
  [className: string]: string;
}

interface IRichTextProps {
  children?: React.ReactNode;
  content?: string;
  containerClassName?: string;
  className?: string;
  tag?: React.ElementType;
  cssModule?: CSSModule;
}

const RichText = React.forwardRef<HTMLDivElement, IRichTextProps>(
  (
    {
      children,
      containerClassName = '',
      content = null,
      tag = 'section',
      className = '',
      cssModule = {},
      ...attributes
    },
    ref,
  ) => {
    const Tag = tag;
    if (!content) {
      return null;
    }
    const classes = mapToCssModules(classNames(className, css.contentContainer), cssModule);

    return (
      <Tag className={containerClassName}>
        <div
          {...attributes}
          ref={ref}
          dangerouslySetInnerHTML={{ __html: content }}
          className={classes}
        />
        {children}
      </Tag>
    );
  },
);

RichText.displayName = 'RichText';
export default RichText;
